import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import { BookingProvider } from './context/BookingContext'
import './index.css'
import './i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BookingProvider>
        <App />
      </BookingProvider>
    </HelmetProvider>
  </React.StrictMode>,
)
